import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IUmkreissucheResponseRow } from 'fa-kt.types';
import { BehaviorSubject } from 'rxjs';
import { UmkreissucheService } from '../service';

@Component({
  selector: 'fa-kt-umkreissuche-list',
  templateUrl: './umkreissuche-list.component.html',
  styleUrls: ['./umkreissuche-list.component.css'],
})
export class UmkreissucheListComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() height = 'calc(100vh - 324px)';

  @Output() select: EventEmitter<string> = new EventEmitter<string>();

  constructor(public umkreissuche: UmkreissucheService) {}

  public set(umkreissuche: IUmkreissucheResponseRow) {}
}
